import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import useIsInsideApp from 'hooks/useIsInsideApp';

import { Container, Content, Button, Logo } from './styles';

interface HeaderProps {
  openMenu: () => void;
  goBack: () => void;
}

const Header = ({ openMenu, goBack }: HeaderProps) => {
  const isInsideApp = useIsInsideApp();
  const companyConfiguration = useSelector((state: RootState) => state.companyConfiguration.configuration);
  const companyConfigurationLogo = useMemo(
    () => companyConfiguration?.ownerImageLogoBytes || companyConfiguration?.ownerImageLogo || '/corporate/images/logo-netviajes.svg',
    [companyConfiguration],
  );

  return (
    <Container>
      <Content>
        {isInsideApp && (
          <Button onClick={goBack}>
            <img alt="back" src="/corporate/images/back-arrow.svg" width={12} />
          </Button>
        )}
        <Logo src={companyConfigurationLogo} />
        <Button onClick={openMenu}>
          <img alt="menu" src="/corporate/images/menu.svg" />
        </Button>
      </Content>
    </Container>
  );
};

export default Header;
